// extracted by mini-css-extract-plugin
export default {"message":"lvsWL","container":"Vw7I9","icon":"f54Mb","description":"Wi9LF","success":"Gm603","error":"Z_l7C"};